import React from "react";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { useSegment } from "analytics/segment";
import {
  CreateTaskFormPropsInput,
  setCreateTaskModalState,
} from "tasks/actions";
import { useStore as useTasksStore } from "tasks/store";

interface ReportIssueButtonProps extends CreateTaskFormPropsInput {
  eventName?: string;
  label?: string;
}

export const ReportIssueButton = (props: ReportIssueButtonProps) => {
  const {
    label = "Report an issue",
    eventName = "task_panel",
    subjectId,
    subjectType,
    taskType,
  } = props;

  const { dispatch } = useTasksStore();
  const { track } = useSegment();

  return (
    <Button
      title={label}
      onClick={() => {
        track({
          action: "click",
          element: "report_issue_button",
          eventName,
          props: {
            subjectId,
            subjectType,
            taskType,
          },
        });
        dispatch(
          setCreateTaskModalState({
            isOpen: true,
            subjectId,
            subjectType,
            taskType,
          }),
        );
      }}
    >
      {label}
    </Button>
  );
};
